import React from "react";
import { Col, Container, Ratio, Row } from "react-bootstrap";

const SectionComing = () => {
  return (
    <section className="bg-dark text-light pt-4">
      <Container className="mb-5">
        <Row className="pt-3 text-center border-bottom border-danger mb-5">
          <Col>
            <h2 className="pb-3">COMING SOON</h2>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col md={5} className="text-left mb-5">
            <div className="embed-responsive">
              <Ratio aspectRatio="4x3">
                <iframe
                  src="https://www.youtube.com/embed/73_1biulkYk"
                  title="Deadpool & Wolverine | Official Trailer | In Theaters July 26"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              </Ratio>
            </div>
          </Col>
          <Col md={5} className="text-left">
            <h4>
              <b>DEADPOOL 2</b>
            </h4>
            <p>
              1h 59min |{" "}
              <span className="text-danger">Action, Adventure, Comedy</span> |
              May 18, 2018 (USA)
            </p>
            <p className="pt-4">
              After losing Vanessa (Morena Baccarin), the love of his life,
              4th-wall breaking mercenary Wade Wilson aka Deadpool (Ryan
              Reynolds) must assemble a team and protect a young, full-figured
              mutant Russell Collins aka Firefist (Julian Dennison) from Cable
              (Josh Brolin).
            </p>
            <p>
              <b>Director:</b> David Leitch <br />
              <b>Writers:</b> Rhett Reese, Paul Wernick <br />
              <b>Stars:</b> Ryan Reynolds, Josh Brolin, Morena Baccarin
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SectionComing;
